module.exports = __webpack_public_path__ + "images/8d8643fc2aa881c185fd1288cb7e99b3.png";